// dependencies imports ⇒
import React, { useEffect, useRef, useState } from "react";
import Validator from "aadhaar-validator";

// assets and scss imports ⇒
import "./aadharVerification.scss";
// project file imports(UI components) ⇒
import PrimaryButton from "../../../common/Buttons/PrimaryButton";
import AbhaConfirmationDetails from "../../../common/AbhaConfirmationDetails";
import AbhaOtpContainer from "../AbhaOtpContainer";
import AbhaMobileNumberLink from "../AbhaMobileNumberLink";
import AbhaCreateAddress from "../AbhaCreateAddress";
import SecondaryButton from "../../../common/Buttons/SecondaryButton";
import backArrow from "../../../../assets/back_arrow_gray.svg";
// const file imports(helper methods, etc) ⇒
import {
  enrollAadhar,
  enrollResendOtp,
  enrollVerifyOtp,
} from "../../APIHandler";
import {
  ENROLL_AADHAR,
  ENROLL_RESEND_OTP,
  ENROLL_VERIFY_OTP,
} from "../../APIHandler/apiConstants";
import { AADHAR_VALIDATION_ERROR, OTP_VALIDATION_ERROR } from "../../Constants";
import { handleAbhaGenderFormat } from "../helper";
import { PROD } from "../../../common/config";

const AadhaarVerification = (props) => {
  // const declarations ⇒
  const {
    aadharSteps,
    enteredMobileNumber,
    existingPatientDetails,
    handleMobileNumberChange,
    handleSteps,
    handleSubmitAbhaPatientDetails,
    handleSubmitExistingPatientDetails,
    handleBack,
  } = props;
  const [aadharInput, setAadharInput] = useState({
    first: "",
    middle: "",
    last: "",
  });
  const [inputFocused, setInputFocused] = useState("");
  const [aadharError, setAadharError] = useState("");

  const [disableActionButton, setDisableActionButton] = useState(true);
  const [errorMessage, setErrorMessage] = useState();
  const [transactionID, setTransactionID] = useState("");
  const [aadharMobileNumber, setAadharMobileNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [disableAadharOtpButton, setDisableAadharOtpButton] = useState(true);
  const [patientId, setPatientId] = useState("");
  const [abhaNumber, setAbhaNumber] = useState("");
  const [abhPatientDetails, setAbhPatientDetails] = useState({});
  const [hideTimerResendBtn, setHideTimerResendBtn] = useState(false);

  const firstRef = useRef();
  const middleRef = useRef();
  const lastRef = useRef();

  // let or var declarations ⇒

  // life cycle methods ⇒

  useEffect(() => {
    let aadharNumber =
      aadharInput.first + aadharInput.middle + aadharInput.last;
    if (aadharNumber?.length === 12) {
      setDisableActionButton(false);
    } else {
      setDisableActionButton(true);
    }
  }, [aadharInput]);

  useEffect(() => {
    if (otp?.length < 6) {
      setDisableAadharOtpButton(true);
    } else {
      setDisableAadharOtpButton(false);
    }
  }, [otp]);

  // API Calls ⇒

  const enrollAadharAPICall = (reqPayload) => {
    const aadharResponse = enrollAadhar(ENROLL_AADHAR, reqPayload); //Fetch API Data
    aadharResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setAadharError("");
          setDisableActionButton(false);
          let responseData = res?.data;
          let mobileNumber = responseData.message.split(" ");
          handleAadharData(
            reqPayload?.aadhar_number,
            responseData?.txnId,
            mobileNumber[mobileNumber.length - 1]
          );
        } else if (res?.data?.statusCode === 503) {
          setDisableActionButton(false);
          setAadharError(res?.data?.message);
        } else if (res?.data?.statusCode === 400) {
          setDisableActionButton(false);
          setAadharError(AADHAR_VALIDATION_ERROR.THIRD_ERROR);
        } else {
          setDisableActionButton(false);
          setAadharError(
            res?.data?.code
              ? AADHAR_VALIDATION_ERROR.SECOND_ERROR
              : AADHAR_VALIDATION_ERROR.FIRST_ERROR
          );
        }
      } else {
        setAadharError(AADHAR_VALIDATION_ERROR.SECOND_ERROR);
        setDisableActionButton(false);
      }
    });
  };

  const enrollVerifyOtpAPICall = (reqPayload) => {
    const aadharResponse = enrollVerifyOtp(ENROLL_VERIFY_OTP, reqPayload); //Fetch API Data
    aadharResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode == 200) {
          setDisableAadharOtpButton(false);
          setOtpError(false);
          let responseData = res?.data;
          handlePatientId(responseData?.patient_master_id);
          if (responseData?.isNew) {
            if (responseData?.is_aadhar_mobile_no) {
              handleAbhaNumber(responseData?.ABHAProfile?.ABHANumber);
              handleSteps(4);
            } else {
              handleSteps(3);
            }
          } else {
            handleAbhaNumber(responseData?.ABHAProfile?.ABHANumber);
            setAbhPatientDetails({
              name: `${responseData?.ABHAProfile?.firstName} ${
                responseData?.ABHAProfile?.middleName
                  ? responseData?.ABHAProfile?.middleName
                  : ""
              } ${
                responseData?.ABHAProfile?.lastName
                  ? responseData?.ABHAProfile?.lastName
                  : ""
              }`,
              dob: responseData?.ABHAProfile?.dob,
              gender: handleAbhaGenderFormat(responseData?.ABHAProfile?.gender),
              address: responseData?.ABHAProfile?.address,
              state: responseData?.ABHAProfile?.stateName,
              preferred_abha_address:
                responseData?.ABHAProfile?.phrAddress?.length > 0 &&
                responseData?.ABHAProfile?.phrAddress[0]?.split("@")[0],
            });
            handleSteps(5);
          }
        } else {
          setErrorMessage(
            res?.data?.code
              ? res?.data?.code?.toLowerCase() == "abdm-1100"
                ? OTP_VALIDATION_ERROR?.THIRD_ERROR
                : OTP_VALIDATION_ERROR?.SECOND_ERROR
              : OTP_VALIDATION_ERROR?.FIRST_ERROR
          );
          setOtpError(true);
          setDisableAadharOtpButton(false);
        }
      } else {
        setErrorMessage(OTP_VALIDATION_ERROR.SECOND_ERROR);
        setOtpError(true);
        setDisableAadharOtpButton(false);
      }
    });
  };

  const enrollResendOtpAPICall = (reqPayload) => {
    const aadharResendOTPResponse = enrollResendOtp(
      ENROLL_RESEND_OTP,
      reqPayload
    ); //Fetch API Data
    aadharResendOTPResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          console.log("res", res);
          setTransactionID(res?.data?.txnId);
          setHideTimerResendBtn(false);
        } else if (res?.data?.statusCode === 503) {
          setErrorMessage(res?.data?.message);
          setOtpError(true);
          setHideTimerResendBtn(true);
        } else {
          setErrorMessage(
            res?.data?.code?.toLowerCase() === "abdm-1100"
              ? OTP_VALIDATION_ERROR?.THIRD_ERROR
              : OTP_VALIDATION_ERROR?.SECOND_ERROR
          );
          setOtpError(true);
        }
      }
    });
  };
  // Helper methods ⇒
  const handleAbhaPatientDetails = (details) => {
    setAbhPatientDetails({
      name: details?.name,
      dob: `${details?.dayOfBirth ? details?.dayOfBirth : "01"}-${
        details?.monthOfBirth ? details?.monthOfBirth : "01"
      }-${details?.yearOfBirth}`,
      gender: handleAbhaGenderFormat(details?.gender),
      address: details?.address,
      state: details?.stateName,
      pincode: details?.pincode,
      preferred_abha_address:
        details?.phrAddress && details?.phrAddress?.length > 0
          ? details?.phrAddress[0]?.split("@")[0]
          : details?.preferredAbhaAddress
          ? details?.preferredAbhaAddress?.split("@")[0]
          : "",
    });
    handleSteps(5);
  };

  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  // Actions ⇒

  const handleAadharInput = (e, position) => {
    setDisableActionButton(false);
    let value = e.target.value;
    if (value?.length <= 4) {
      setAadharInput({
        ...aadharInput,
        [position]: value,
      });
    }
    if (value.length === 4 && position === "first") {
      middleRef.current.focus();
      setInputFocused("middle");
    } else if (value.length === 4 && position === "middle") {
      lastRef.current.focus();
      setInputFocused("last");
    }
  };

  const handleOnFocus = (position) => {
    setInputFocused(position);
  };

  const handleOnKeyDown = (e) => {
    const pressedKey = e.key;
    switch (pressedKey) {
      case "Backspace":
      case "Delete": {
        if (aadharInput[inputFocused]?.length === 0) {
          if (inputFocused === "last") {
            middleRef.current.focus();
          } else if (inputFocused === "middle") {
            firstRef.current.focus();
          }
        }
        break;
      }
      default: {
        if (
          e.key?.toLowerCase() === "e" ||
          e.key === "+" ||
          e.key === "-" ||
          e.key === "." ||
          e.key === "ArrowUp" ||
          e.key === "ArrowDown"
        ) {
          e.preventDefault();
        }
        break;
      }
    }
  };

  const handleAadharSubmit = () => {
    handleVerifyAadhar();
  };

  const handleVerifyAadhar = () => {
    let aadharNumber =
      aadharInput.first + aadharInput.middle + aadharInput.last;
    if (Validator.isValidNumber(aadharNumber)) {
      setAadharError("");
      setDisableActionButton(true);
      let payload = {
        aadhar_number: aadharNumber,
      };
      enrollAadharAPICall(payload);
    } else {
      setAadharError(AADHAR_VALIDATION_ERROR?.FIRST_ERROR);
      setDisableActionButton(false);
    }
  };

  const handleAadharData = (aadhar_number, transaction_id, aadharMobile) => {
    setAadharNumber(aadhar_number);
    setAadharMobileNumber(aadharMobile);
    setTransactionID(transaction_id);
    handleSteps(2);
  };

  const handleOTPChange = (otpInput) => {
    setOtp(otpInput);
  };

  const handleAadharOtpVerification = () => {
    setDisableAadharOtpButton(true);
    let payload = {
      otp: otp,
      txnid: transactionID,
      mobile_number: enteredMobileNumber,
      patient_account_id: existingPatientDetails?.patient_account_id,
    };
    enrollVerifyOtpAPICall(payload);
  };

  const handleResendOTP = () => {
    let payload = {
      aadhar_number: aadharNumber,
    };
    enrollResendOtpAPICall(payload);
  };

  const handlePatientId = (patient_id) => {
    setPatientId(patient_id);
  };

  const handleAbhaNumber = (abha_number) => {
    setAbhaNumber(abha_number);
  };

  // create UI ⇒

  const aadharInputSectionUI = () => {
    return (
      <div className="pavc-aadhar-input-container pavc-pd">
        <div className="pavc-input-label">Enter Your Aadhaar Number</div>
        <div className="pavc-input-container-view">
          <div
            className={
              "pavc-input-container " +
              (aadharError ? "pavc-input-container-error" : "")
            }
          >
            <input
              className="pavc-input"
              placeholder="****"
              maxLength={4}
              type="number"
              value={aadharInput.first}
              onChange={(e) => handleAadharInput(e, "first")}
              ref={firstRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("first")}
              // onPaste={handleOnPaste}
            />
          </div>
          <div
            className={
              "pavc-input-container " +
              (aadharError ? "pavc-input-container-error" : "")
            }
          >
            <input
              className="pavc-input"
              placeholder="****"
              maxLength={4}
              type="number"
              value={aadharInput.middle}
              onChange={(e) => handleAadharInput(e, "middle")}
              ref={middleRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("middle")}
              // onPaste={handleOnPaste}
            />
          </div>
          <div
            className={
              "pavc-input-container " +
              (aadharError ? "pavc-input-container-error" : "")
            }
          >
            <input
              className="pavc-input"
              placeholder="****"
              maxLength={4}
              type="number"
              value={aadharInput.last}
              onChange={(e) => handleAadharInput(e, "last")}
              ref={lastRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("last")}
              // onPaste={handleOnPaste}
            />
          </div>
        </div>
        {aadharError && <div className="pavc-input-error">{aadharError}</div>}
        <div className="pavc-input-text">Enter your 12 digit Aadhar number</div>
        <div className="anvv-continue-btn-wrapper">
          <PrimaryButton
            title="Continue"
            disabled={disableActionButton}
            handleButtonClick={handleAadharSubmit}
          />
        </div>
      </div>
    );
  };

  const aadharOtpInputSection = () => {
    return (
      <div className="pavc-pd">
        <AbhaOtpContainer
          otpLabel="Enter OTP"
          otpContent={getOtpContent()}
          otp={otp}
          otpError={otpError}
          otpErrorMessage={errorMessage}
          hideTimerResendBtn={hideTimerResendBtn}
          disabled={disableAadharOtpButton}
          handleOTPChange={handleOTPChange}
          handleResendOTP={handleResendOTP}
          handleSubmit={handleAadharOtpVerification}
        />
      </div>
    );
  };

  const aadharConfirmationSection = () => {
    return (
      <div className="pavc-aadhar-conf-section">
        <div className="pavc-back-btn-container">
          <img
            src={backArrow}
            alt=""
            className="pavc-back-btn"
            onClick={handleBack}
          />
        </div>
        <div className="pavc-aadhar-conf-section-heading">
          <h5>Confirmation!</h5>
          <p>
            Patient Details will be updated as per <br />
            the ABHA Address "
            <span className="pavc-aadhar-conf-section-heading">
              {getAbhaAddress(abhPatientDetails?.preferred_abha_address)}
            </span>
            ".Do you want to continue ?
          </p>
        </div>
        <AbhaConfirmationDetails
          appointmentDetails={existingPatientDetails}
          abhPatientDetails={abhPatientDetails}
        />
        <div className="pd-abha-qr-data-confirmation-footer-container">
          <div className="pd-abha-qr-data-confirmation-footer-left-btn">
            <SecondaryButton
              title="No"
              handleButtonClick={() =>
                handleSubmitExistingPatientDetails(
                  abhPatientDetails?.preferred_abha_address,
                  abhPatientDetails?.ABHANumber
                )
              }
            />
          </div>
          <div className="pd-abha-qr-data-confirmation-footer-right-btn">
            <PrimaryButton
              title="Yes"
              handleButtonClick={() =>
                handleSubmitAbhaPatientDetails(abhPatientDetails)
              }
            />
          </div>
        </div>
      </div>
    );
  };

  const aadharVerifyDifferentMobileNumber = () => {
    return (
      <div className="pavc-pd">
        <AbhaMobileNumberLink
          aadharNumber={aadharNumber}
          transactionID={transactionID}
          aadharMobileNumber={aadharMobileNumber}
          enteredMobileNumber={enteredMobileNumber}
          patientId={patientId}
          handleSteps={handleSteps}
          handleAbhaNumber={handleAbhaNumber}
          handleMobileNumberChange={handleMobileNumberChange}
        />
      </div>
    );
  };

  const aadharCreateAbha = () => {
    return (
      <div className="pavc-pd">
        <AbhaCreateAddress
          aadharNumber={aadharNumber}
          transactionID={transactionID}
          aadharMobileNumber={aadharMobileNumber}
          patientId={patientId}
          abhaNumber={abhaNumber}
          handleSteps={handleSteps}
          handleAbhaPatientDetails={handleAbhaPatientDetails}
        />
      </div>
    );
  };

  const getOtpContent = () => {
    return (
      <div>
        <div className="pavc-otp-content-text">
          We just sent you an OTP on your mobile number which is linked to your
          Aadhar number
        </div>
        <div className="pavc-otp-aadhar-text">
          Aadhar Mobile Number {aadharMobileNumber}
        </div>
      </div>
    );
  };

  return (
    <div className="patient-aadhar-verification-container">
      {aadharSteps === 1 && aadharInputSectionUI()}
      {aadharSteps === 2 && aadharOtpInputSection()}
      {aadharSteps === 3 && aadharVerifyDifferentMobileNumber()}
      {aadharSteps === 4 && aadharCreateAbha()}
      {aadharSteps === 5 && aadharConfirmationSection()}
    </div>
  );
};

// export ⇒

export default AadhaarVerification;
